export default "__VITE_ASSET__JHgqFChh__"